import React from 'react';
import FormPage from '../../../../../../common/DealApplicationDrawer/Components/Page/FormPage';
import { DealTermsLogType as DealTermsLogType } from '../DealTermsLoggingDrawer/DealTermsLoggingDrawer';
import styles from './DealTermsLog.module.scss';
import { useAppSelector } from '../../../../../../app/hooks';

interface DealTermsLogProps {
    formData: DealTermsLogType & { currentLogId?: string };
    dealTermsLoggingConfig: any;
    setIsFormValid: (isValid: boolean) => void;
    onUpdateLog: (updatedLog: DealTermsLogType) => void;
    logPositionMap: Map<string, { logDate: string; logPosition: number }>;
}

export const DealTermsLog: React.FC<DealTermsLogProps> = ({
    formData,
    dealTermsLoggingConfig,
    setIsFormValid,
    onUpdateLog,
    logPositionMap,
}) => {
    const userName = useAppSelector((state) => state.user.userData.userName);

    const updateDealLogs = (key: string, value: string | string[] | (string | null)[]) => {
        // Filter out null values if array
        let cleanedValue: string | string[];
        if (Array.isArray(value)) {
            cleanedValue = value.filter((v): v is string => v !== null) as string[];
        } else {
            cleanedValue = value;
        }

        if (key === 'logDate') {
            const updatedLog = {
                ...formData,
                logDate: Array.isArray(cleanedValue) ? cleanedValue[0] : cleanedValue,
                dealTerms: {
                    ...formData.dealTerms,
                    [key]: Array.isArray(cleanedValue) ? cleanedValue[0] : cleanedValue,
                },
            };
            onUpdateLog(updatedLog);
            return;
        }

        const updatedLog = {
            ...formData,
            dealTerms: {
                ...formData.dealTerms,
                [key]: cleanedValue,
            },
        };
        onUpdateLog(updatedLog);
    };

    return (
        <div className={styles.logContainer}>
            <FormPage
                step={0}
                setIsFormValid={setIsFormValid}
                page={dealTermsLoggingConfig?.mainConfig?.additionalDetailsConfig?.pages[0]?.config}
                formData={formData}
                updateDealLogs={updateDealLogs}
                logPositionMap={logPositionMap}
                currentLogId={formData.currentLogId}
            />
        </div>
    );
};

export default DealTermsLog;
